import axios from 'axios';
import { getAPIURL } from 'config/constants';

export const fetchVirtualAiStagingOrders = async (token: string, listing_id: number) => {
  try {
    const config = { headers: { token } };
    const response = await axios.get(`${getAPIURL()}/aiStagingOrder/${listing_id}`, config);
    return response.data;
  } catch (error) {
    console.log('[fetchVirtualAiStagingOrders] error: ', error);
    return null;
  }
};

export async function createAiStagingOrder(
  token: string,
  orderData: any,
  listing_id: number,
  service_offer_id: number,
) {
  try {
    const config = { headers: { token } };
    const params = {
      listing_id,
      service_offer_id,
      pictures_with_config: orderData,
    };
    const response = await axios.post(`${getAPIURL()}/aiStagingOrder/`, params, config);
    return response.data;
  } catch (error) {
    console.log('[fetchVirtualAiStagingOrders] error: ', error);
    return null;
  }
}

export async function createAiStagingIteration(
  token: string,
  orderData: any,
  listing_id: number,
  render_id: string,
  previous_variation_count: number,
) {
  try {
    const config = { headers: { token } };
    const params = {
      listing_id,
      previous_variation_count,
      config: orderData,
    };
    const response = await axios.post(
      `${getAPIURL()}/aiStagingOrder/iteration/${render_id}`,
      params,
      config,
    );
    return response.data;
  } catch (error) {
    console.log('[fetchVirtualAiStagingOrders] error: ', error);
    return null;
  }
}
